class PatientService {
    mapFromResponseToRequest(patient) {
        return {
            id: patient && patient.patId,
            patPublicInformation: false,
            patientIdentifiers: patient && patient.patientIdentifiers ? patient.patientIdentifiers : [],
            originalConcurrencyUpdatedAt: patient ? patient.originalConcurrencyUpdatedAt : '',
            genderId: patient ? patient.gender.id : null,
            patBirthdate: patient ? patient.patBirthdate : '',
            patDeathDate: patient ? patient.patDeathDate : '',
            patMiddleName: patient ? patient.patMiddleName : '',
            patName: patient ? patient.patName : '',
            patSurname1: patient ? patient.patSurname1 : '',
            patSurname2: patient ? patient.patSurname2 : '',
            address: patient && patient.address ? this.parseAddress(patient.address) : {},
            contactInformation: patient && patient.contactInformation ? this.parseContactInformation(patient.contactInformation) : {}
        }
    }
    parseContactInformation(contactInformation) {
        return {
            email: contactInformation.email,
            mainPhone: contactInformation.mainPhone,
            otherPhone1: contactInformation.otherPhone1,
            otherPhone2: contactInformation.otherPhone2
        }
    }
    parseAddress(address) {
        return {
            address: address.address,
            notes: address.notes,
            postalCode: address.postalCode,
            countryId: address.country ? address.country.id : null,
            municipalityId: address.municipality ? address.municipality.id : null,
            provinceId: address.province ? address.province.id : null
        }
    }
}

export default new PatientService()
